import * as React from 'react';
import { cn } from '@/lib/utils';
import { Input } from '@/components/ui/input';

/**
 * LabeledField — the prototype `Field(label, value, mono)` helper. A small
 * uppercase label over a shadcn `Input`. Read-only mono fields (domain, tenant
 * id) render with `font-mono`.
 */
export const LabeledField = React.forwardRef<
  HTMLInputElement,
  React.InputHTMLAttributes<HTMLInputElement> & { label: string; mono?: boolean; hint?: string }
>(({ label, mono, hint, className, ...props }, ref) => {
  return (
    <div className="mb-3.5">
      <label className="mb-1.5 block text-[11px] font-semibold text-cs-text-muted">{label}</label>
      <Input
        ref={ref}
        className={cn(mono && 'font-mono text-[12.5px]', className)}
        {...props}
      />
      {hint && <p className="mt-1 text-[11px] text-cs-text-muted">{hint}</p>}
    </div>
  );
});
LabeledField.displayName = 'LabeledField';
